"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.slice.js");
var _pascalize = _interopRequireDefault(require("./pascalize"));
var _isNotString = _interopRequireDefault(require("./helpers/isNotString"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * convert a string to camel casing and treat - and _ as word delimiters
 *
 * @example
 * camelize('some_snake_case') => 'someSnakeCase'
 * camelize('some-pipe-case') => 'somePipeCase'
 * camelize('some word') => 'someWord'
 * camelize('SomePascalCase') => 'somePascalCase'
 */
var camelize = function camelize(str) {
  if ((0, _isNotString.default)(str)) return '';
  var pascal = (0, _pascalize.default)(str);
  return "".concat(pascal[0].toLowerCase()).concat(pascal.slice(1));
};
var _default = exports.default = camelize;